module.exports = __webpack_public_path__ + "img/havoc.3ab181c4.png";